import { API } from "../auth/authApi";

export const getSupportChatApi = (params) => {
    return API.get("/support/chat", { params });
};

export const getSupportChatMessagesApi = (params) => {
    return API.get("/support/chat/message", { params });
};

export const sendSupportMessageApi = (data) => {
    return API.post("/support/admin/message", data);
};